export default "__VITE_ASSET__B26Vo2gQ__"